import {  FETCH_STATEMENTS, FETCH_REVENUE_BREAKDOWN } from '../actionTypes';
import axios from 'axios';
import { showLoader, hideLoader } from './loader';

const SERVICE = 'revenues';

export const createStatement = () => (dispatch) => {
  return new Promise((response, reject) => {
  })
}

export const fetchList = (userId) => (dispatch) => {
  axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
  dispatch(showLoader());
  return new Promise((respond,rej) => {
    axios.get(SERVICE).then((res) => {
      dispatch({
        type: FETCH_STATEMENTS,
        payload: res.data
      });
      dispatch(hideLoader());
      respond(res.data);
    });
  });
}

export const getRevenueBreakDown = (revenue) => (dispatch) => {
  axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
  dispatch(showLoader());
  return new Promise((respond,rej) => {
    axios.get(`${SERVICE}/breakDown`, { params: revenue }).then((res) => {
      dispatch({
        type: FETCH_REVENUE_BREAKDOWN,
        payload: res.data
      });
      dispatch(hideLoader());
      respond(res.data);
    });
  });
}

export const fetchInfo = (statementId) => (dispatch) => {
  return new Promise((respond,rej) => {
  });
}



// WEBPACK FOOTER //
// ./src/store/actions/statements.js